import { createSlice } from '@reduxjs/toolkit';
import {
  healthCheckCSRFUrl,
  healthCheckLoginUrl,
  healthCheckLogoutUrl,
  healthCheckSessionUrl,
} from '@app/definition/API';
import {
  getInitialState,
  getSessionExtraReducers,
  getSessionReducers,
  getSessionThunks,
  SessionStateI,
} from '../../session/sessionSlice';
import setUserData from './setUserDataThunk';

export type HealthCheckSessionStateI = SessionStateI;

export const sessionThunks = getSessionThunks(setUserData, {
  csrf: healthCheckCSRFUrl,
  check: healthCheckSessionUrl,
  login: healthCheckLoginUrl,
  logout: healthCheckLogoutUrl,
});

const initialState: HealthCheckSessionStateI = {
  ...getInitialState(),
};

export default createSlice({
  name: 'businessSession',
  initialState,
  reducers: {
    ...getSessionReducers<HealthCheckSessionStateI>(),
  },
  extraReducers: {
    ...getSessionExtraReducers(sessionThunks),
  },
});
